import { BanknotesIcon } from '@heroiconsv2/react/24/outline'
import { formatPrice } from 'lib/utils'
import { calculateBookingAjarleeAmount, getAjarleeServiceFee, getBookingDiscountBreakdown } from '../bookingDetailHelpers'
import AjarleePercentageBaseTag from './AjarleePercentageBaseTag'
import BookingDiscountedAmount from './BookingDiscountedAmount'
import { Band, MoneyRow, Panel, SectionCard } from './BookingSection'

const BookingAjarleePaymentCard = ({ bookingData, t, isCompanyRole, hasAdminAccess }) => {
  if (isCompanyRole && !hasAdminAccess) return null

  const discounts = getBookingDiscountBreakdown(bookingData)

  const omr = value => `${formatPrice(value || 0, true)} ${t('common.omr')}`
  const ajarleeAmount = Number(calculateBookingAjarleeAmount(bookingData)) || 0

  return (
    <SectionCard icon={BanknotesIcon} tone="green" title={`${t('common.ajarleeName')} ${t('booking.sections.paymentSummary')}`}>
      <Panel className="py-3">
        <MoneyRow label={t('booking.orderSummary.serviceFees')} sign="">
          <BookingDiscountedAmount discount={discounts.service} t={t} />
        </MoneyRow>
        <MoneyRow
          label={`${t('common.ajarleeName')} ${bookingData?.ajarleePercentage != null ? formatPrice(bookingData.ajarleePercentage, true) : '0.000'}%:`}
          sign="+"
          signClassName="text-emerald-600"
        >
          {omr(ajarleeAmount)}
        </MoneyRow>
        <AjarleePercentageBaseTag bookingData={bookingData} t={t} variant="emerald" />

        <Band label={t('booking.sections.ajarleeAmount')} tone="green">
          {omr(ajarleeAmount + (getAjarleeServiceFee(bookingData) || 0))}
        </Band>
      </Panel>
    </SectionCard>
  )
}

export default BookingAjarleePaymentCard
